<chart [type]="'pie'" [data]="pieData" [options]="pieOptions"></chart>